import { makeStyles } from 'tss-react/mui';
import { keyframes } from 'tss-react';

export const useStyles = makeStyles()(() => {
  const ellipsis = keyframes`
    0%   { content: ''; }
    25%  { content: '.'; }
    50%  { content: '..'; }
    75%  { content: '...'; }
    100% { content: ''; }
  `;

  return {
    loading: {
      '&:after': {
        overflow: 'hidden',
        animation: `${ellipsis} steps(1,end) 1s infinite`,
        content: "''",
      },
    },
  };
});
